// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recipientsDetails {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 30px;
	background: orange;
	border-radius: 50%;
	margin-right: 10px;
	color: #000;
}

.custom-table {
	border-collapse: collapse;
	width: 100%;
	border: none;
}

.custom-table th {
	font-size: 16px;
	font-weight: 400;
	line-height: 19px;
	letter-spacing: 0em;
	text-align: left;
	padding: 5px 0;
	border: none;
}

.custom-table td {
	font-size: 14px;
	font-weight: 400;
	line-height: 17px;
	letter-spacing: 0em;
	text-align: left;
	color: 'white';
	padding: 4px 0;
	border: none;
}

.custom-table td:nth-child(even) {
	color: #8e8e8e;
}

.custom-table2 {
	width: 100%;
	margin-top: 20px;
	border-collapse: collapse;
	border-radius: 12px;
	border-style: hidden;
	box-shadow: 0 0 0 1px #8e8e8e;
}

.custom-table2 tbody {
	text-align: center;
}

.custom-table2 th,
.custom-table2 td {
	border: 1px solid #8e8e8e;
	padding: 8px;
}

.custom-table2 th {
	color: #8e8e8e;
}

::-webkit-scrollbar {
	width: 7px;
}

::-webkit-scrollbar-thumb {
	background-color: #d9d9d9;
	border-radius: 6px;
}

::-webkit-scrollbar-thumb:hover {
	background-color: #444;
}

::-webkit-scrollbar-track {
	background: #f7f9f5;
}

.parentContainer::-webkit-scrollbar {
	display: none;
}

.parentContainer {
	scrollbar-width: none;
	-ms-overflow-style: none;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Pages/Dashboard/OrganizationDashboard/organization-dashboard.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,yBAAyB;CACzB,WAAW;CACX,YAAY;AACb;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,mBAAmB;CACnB,gBAAgB;CAChB,cAAc;CACd,YAAY;AACb;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,mBAAmB;CACnB,gBAAgB;CAChB,cAAc;CACd,cAAc;CACd,YAAY;AACb;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,yBAAyB;CACzB,mBAAmB;CACnB,oBAAoB;CACpB,6BAA6B;AAC9B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;;CAEC,yBAAyB;CACzB,YAAY;AACb;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,wBAAwB;AACzB","sourcesContent":[".recipientsDetails {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 30px;\n\theight: 30px;\n\tbackground: orange;\n\tborder-radius: 50%;\n\tmargin-right: 10px;\n\tcolor: #000;\n}\n\n.custom-table {\n\tborder-collapse: collapse;\n\twidth: 100%;\n\tborder: none;\n}\n\n.custom-table th {\n\tfont-size: 16px;\n\tfont-weight: 400;\n\tline-height: 19px;\n\tletter-spacing: 0em;\n\ttext-align: left;\n\tpadding: 5px 0;\n\tborder: none;\n}\n\n.custom-table td {\n\tfont-size: 14px;\n\tfont-weight: 400;\n\tline-height: 17px;\n\tletter-spacing: 0em;\n\ttext-align: left;\n\tcolor: 'white';\n\tpadding: 4px 0;\n\tborder: none;\n}\n\n.custom-table td:nth-child(even) {\n\tcolor: #8e8e8e;\n}\n\n.custom-table2 {\n\twidth: 100%;\n\tmargin-top: 20px;\n\tborder-collapse: collapse;\n\tborder-radius: 12px;\n\tborder-style: hidden;\n\tbox-shadow: 0 0 0 1px #8e8e8e;\n}\n\n.custom-table2 tbody {\n\ttext-align: center;\n}\n\n.custom-table2 th,\n.custom-table2 td {\n\tborder: 1px solid #8e8e8e;\n\tpadding: 8px;\n}\n\n.custom-table2 th {\n\tcolor: #8e8e8e;\n}\n\n::-webkit-scrollbar {\n\twidth: 7px;\n}\n\n::-webkit-scrollbar-thumb {\n\tbackground-color: #d9d9d9;\n\tborder-radius: 6px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n\tbackground-color: #444;\n}\n\n::-webkit-scrollbar-track {\n\tbackground: #f7f9f5;\n}\n\n.parentContainer::-webkit-scrollbar {\n\tdisplay: none;\n}\n\n.parentContainer {\n\tscrollbar-width: none;\n\t-ms-overflow-style: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
